export enum EventsList {
  FilePageChanged = 'FilePageChanged',
  ServerVersionReceived = 'ServerVersionReceived',
}
